// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kxaX","placeholdersHeader":"styles_placeholdersHeader__1eJjz","editorStyle":"styles_editorStyle__TSNGq","placeholdersBox":"styles_placeholdersBox__1l-NG"};